export const SET_PREVIOUS_LOCATION = 'routerHistory/SET_PREVIOUS_LOCATION';
